var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgVerifyIcon = function SvgVerifyIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0389,
    cy: 35.0643,
    r: 34.5193,
    fill: "#DFE0E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7984 22.1038C39.4864 20.6873 37.6539 19.9072 35.6313 19.9072C33.5979 19.9072 31.7593 20.6826 30.4534 22.0903C29.1333 23.5136 28.4901 25.4479 28.6411 27.5365C28.9405 31.6573 32.0762 35.0094 35.6313 35.0094C39.1864 35.0094 42.3167 31.658 42.6208 27.5379C42.7738 25.4681 42.1266 23.5378 40.7984 22.1038ZM47.4973 50.1116H23.7653C23.4546 50.1157 23.147 50.0504 22.8648 49.9206C22.5825 49.7908 22.3328 49.5997 22.1337 49.3613C21.6955 48.8374 21.5188 48.1221 21.6496 47.3986C22.2186 44.242 23.9945 41.5904 26.7857 39.7289C29.2654 38.0764 32.4066 37.1669 35.6313 37.1669C38.856 37.1669 41.9971 38.0771 44.4769 39.7289C47.2681 41.5897 49.0439 44.2413 49.613 47.398C49.7438 48.1214 49.5671 48.8367 49.1289 49.3606C48.9299 49.5992 48.6801 49.7904 48.3979 49.9203C48.1157 50.0502 47.808 50.1156 47.4973 50.1116Z",
    fill: "#A9ADC4"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgVerifyIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/verifyIcon.ce25449575c52358903b12e6d25f9a46.svg";